export function parseMegabytesToGigabytes(
  mb: string | undefined,
  options: Intl.NumberFormatOptions = {},
) {
  if (!mb) {
    return 0;
  }

  const gigabytes = Number.parseFloat(mb) / 1024;

  return Intl.NumberFormat("pl-PL", {
    maximumFractionDigits: 2,
    ...options,
  }).format(gigabytes);
}
